import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-does-inventory-and-availability-of-a-product-work-"
    }}>{`How does inventory and availability of a product work ?`}</h1>
    <p>{`Suppose you've 3 inventories of a product. Now if anyone book this product from
a `}<inlineCode parentName="p">{`02/07/2016`}</inlineCode>{` to `}<inlineCode parentName="p">{`04/07/2016`}</inlineCode>{` , then this product also be available for the next customers in
that dates. Because there are still 2 more inventories available in that particular dates. If the
next two customers book this product in same dates, then for the fourth customers that
dates will be unavailable.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      